import api from './api'
import { API_ENDPOINTS } from '../utils/constants'

/**
 * Service for user profile management
 */
class ProfileService {
  /**
   * Get current user's profile information
   * @returns {Promise<Object>} Profile data including email, firstName, lastName, googleLinked
   */
  async getProfile() {
    const response = await api.get(API_ENDPOINTS.PROFILE)
    return response.data.data || response.data
  }

  /**
   * Get selectable LLM providers and models
   * @returns {Promise<Object>} Provider and model options
   */
  async getLlmOptions() {
    const response = await api.get(API_ENDPOINTS.LLM_OPTIONS)
    return response.data.data || response.data
  }

  /**
   * Update user's password
   * @param {string} currentPassword - The current password
   * @param {string} newPassword - The new password
   * @param {string} confirmPassword - Password confirmation
   * @returns {Promise<Object>} Success response
   */
  async updatePassword(currentPassword, newPassword, confirmPassword) {
    const response = await api.put(API_ENDPOINTS.UPDATE_PASSWORD, {
      currentPassword,
      newPassword,
      confirmPassword,
    })
    return response.data
  }

  /**
   * Update user's preferred LLM provider and models
   * @param {Object} preference - LLM preference
   * @returns {Promise<Object>} Success response
   */
  async updateLlmProvider(preference) {
    const response = await api.put(API_ENDPOINTS.UPDATE_LLM_PROVIDER, preference)
    return response.data
  }

  /**
   * Delete current user's account after server-side safeguards pass
   * @returns {Promise<Object>} Success response
   */
  async deleteAccount() {
    const response = await api.delete(API_ENDPOINTS.DELETE_ACCOUNT)
    return response.data
  }
}

export default new ProfileService()
